import * as React from "react"
import "./about.css"
import We from "./we/we";
import Facts from "./facts/facts";

const About = () => {
    return (
        <section id={`about`} className={`mt-12`}>
            <We isHomePage={true}/>
            <Facts/>
        </section>
    )
}

export default About